import { grantTrackingConsent } from '@/plugins/datadog';
import { startCustifyTracking } from '@/plugins/custify';

let withheld = false;

export const startTracking = () => {
  grantTrackingConsent();
  startCustifyTracking();
};

export const withholdTracking = () => {
  withheld = true;
};

export const resetTracking = () => {
  if (withheld) {
    window.location.href = '/';
  }
};
